import { ArrowRight, Sparkles, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import BrutalButton from "@/components/common/BrutalButton";
import BrutalCard from "@/components/common/BrutalCard";

export default function Hero() {
    return (
        <section
            data-testid="hero-section"
            className="relative overflow-hidden border-b-4 border-ink"
        >
            <div className="absolute -top-24 -right-24 w-[480px] h-[480px] rounded-full bg-brand-pink border-[3px] border-ink hidden md:block" />
            <div className="absolute top-40 right-40 w-24 h-24 rounded-full bg-brand-yellow border-2 border-ink hidden md:block animate-wobble" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28 lg:py-32 grid lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-7 animate-rise">
                    <span className="label-mono inline-flex items-center gap-2 bg-brand-yellow border-2 border-ink rounded-full px-4 py-1.5">
                        <Zap size={14} /> Software · SaaS · Marketing
                    </span>
                    <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black leading-[0.92] tracking-tighter">
                        Bold software{" "}
                        <span className="inline-block bg-brand-blue text-white px-3 -rotate-2 border-2 border-ink shadow-brutal">
                            shipped
                        </span>{" "}
                        in weeks, not quarters.
                    </h1>
                    <p className="mt-7 font-body text-base md:text-lg text-ink/75 max-w-2xl leading-relaxed">
                        Technovale Solutions is a software & digital marketing
                        studio for ambitious SaaS teams. We design distinctive
                        products, build them with production-grade engineers, and
                        growth-loop them with compounding marketing.
                    </p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <BrutalButton
                            as={Link}
                            to="/contact"
                            size="lg"
                            variant="primary"
                            data-testid="hero-cta-primary"
                        >
                            Start a project <ArrowRight size={18} />
                        </BrutalButton>
                        <BrutalButton
                            as={Link}
                            to="/services"
                            size="lg"
                            variant="white"
                            data-testid="hero-cta-secondary"
                        >
                            See services
                        </BrutalButton>
                    </div>
                    <div className="mt-10 flex flex-wrap items-center gap-6">
                        {[
                            { k: "94", l: "Products shipped" },
                            { k: "37", l: "SaaS launches" },
                            { k: "6w", l: "Avg. delivery" },
                        ].map((s) => (
                            <div key={s.l} className="flex items-baseline gap-2">
                                <span className="font-display text-3xl font-black">{s.k}</span>
                                <span className="label-mono text-ink/60">{s.l}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="lg:col-span-5 relative">
                    <BrutalCard bg="orange" className="rotate-2">
                        <div className="aspect-[4/5] rounded-xl overflow-hidden border-2 border-ink">
                            <img
                                src="https://images.unsplash.com/photo-1713188090500-a4fb0d2cf309?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGNvbG9yZnVsJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3Nzc5OTI5NzN8MA&ixlib=rb-4.1.0&q=85"
                                alt="Vibrant abstract"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="mt-5 flex items-center justify-between text-white">
                            <span className="label-mono">Now shipping</span>
                            <Sparkles size={20} />
                        </div>
                    </BrutalCard>
                    <div className="hidden md:block absolute -bottom-8 -left-8 w-44 rotate-[-6deg]">
                        <BrutalCard bg="green" className="p-5">
                            <p className="label-mono">+312% MQLs</p>
                            <p className="font-display text-2xl font-black mt-1 leading-none">
                                Compounding growth, every quarter.
                            </p>
                        </BrutalCard>
                    </div>
                </div>
            </div>
        </section>
    );
}
